import React from "react";
import About from "./components/aboutPage/about";
import Contact from "./components/landingPage/contact/contact";
import LandingPage from "./components/landingPage/landingpage";
import Activities from "./components/activitiesPage/activities";
import Gallery from "./components/gallery/gallery";
import Donate from "./components/DonationPage";
import PageNotFound from "./components/PageNotFound";
import SingleActivity from "./components/activitiesPage/activities/singleActivity";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

function App() {
  return (
    <div>
      <Router>
        <Switch>
          <Route path="/" exact component={LandingPage} />
          <Route path="/about" exact component={About} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/activities" exact component={Activities} />
          <Route path="/activities/:id" exact component={SingleActivity} />
          <Route path="/gallery" exact component={Gallery} />
          <Route path="/donate" exact component={Donate} />
          <Route component={PageNotFound} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
